import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App, { preloadRoute } from "@/App";
import { debugError } from "@/lib/debug";

const container = document.getElementById("root");
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Prerendered route (scripts/prerender.js, full mode) → hydrate in place; plain shell → client render.
// The route's chunk and first-render data are fetched first so hydration is synchronous and adopts the prerendered DOM,
// then one more frame is yielded so hydration never shares a frame with parsing/first paint (Performance Fix 10).
const start = () => {
  if (container.dataset.prerender === "full" && container.firstElementChild) {
    ReactDOM.hydrateRoot(container, app, { onRecoverableError: (err) => { debugError("[hydrate]", err); (window.__hydrateErrors ||= []).push(String(err?.message || err)); } });
  } else {
    ReactDOM.createRoot(container).render(app);
  }
};
const nextFrame = () => new Promise((r) => (document.hidden ? setTimeout(r, 0) : requestAnimationFrame(() => setTimeout(r, 0))));
const routePath = window.location.pathname.replace(/\/+$/, "") || "/";
preloadRoute(routePath).then(nextFrame, nextFrame).then(start);
